import Vue from "vue";
import Router from "vue-router";
import module from "./module";
import Index from "@views/home/Index";

import NotDefined from "@views/NotDefined";
import $store from "../store";
import toLogin from "@libs/login";
import Loading from "@views/Loading";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Index",
      meta: {
        title: "首页",
        keepAlive: true,
        footer: true,
        home: false,
        backgroundColor: "#fff"
      },
      component: Index
    },
    {
      path: "/login",
      name: "Login",
      meta: {
        title: "登录",
        keepAlive: true,
        home: false
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/Login.vue")
    },
    {
      path: "/setTestUser",
      name: "setTestUser",
      meta: {
        title: "登录",
        keepAlive: true,
        home: false
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/setTestUser.vue")
    },
    {
      path: "/user",
      name: "user",
      meta: {
        title: "用户中心",
        keepAlive: true,
        home: false,
        footer: true
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/User.vue")
    },
    {
      path: "/news_detail/:id",
      name: "NewsDetail",
      meta: {
        title: "新闻详情",
        keepAlive: true,
        backgroundColor: "#fff"
      },
      component: () => import("@views/shop/news/NewsDetail.vue")
    },
    {
      path: "/news_list",
      name: "NewsList",
      meta: {
        title: "新闻",
        keepAlive: true,
        backgroundColor: "#fff"
      },
      component: () => import("@views/shop/news/NewsList.vue")
    },
    {
      path: "/myOrder/dispatchList",
      name: "dispatchList",
      meta: {
        title: "我的发货单",
        keepAlive: false
      },
      component: () => import("@views/myOrder/dispatchList")
    },
    {
      path: "/myOrder/cusConfirmDetails",
      name: "cusConfirmDetails",
      meta: {
        title: "用户订单确认",
        keepAlive: false
      },
      component: () => import("@views/myOrder/cusConfirmDetails")
    },
    {
      path: "/myOrder/dispatchBill",
      name: "dispatchBill",
      meta: {
        title: "发货单详情",
        keepAlive: false
      },
      component: () => import("@views/myOrder/dispatchBill")
    },
    ...module,
    {
      path: "/auth/:url",
      name: "Loading",
      meta: {
        title: " 加载中",
        keepAlive: true
      },
      component: Loading
    },
    {
      path: "*",
      name: "NotDefined",
      meta: {
        title: "页面找不到",
        keepAlive: true,
        home: false,
        backgroundColor: "#F4F6FB"
      },
      component: NotDefined
    }
  ],
  scrollBehavior(to, from) {
    from.meta.scrollTop = window.scrollY;
    return { x: 0, y: to.meta.scrollTop || 0 };
  }
});

const { back, replace } = router;

router.back = function() {
  this.isBack = true;
  back.call(router);
};
router.replace = function(...args) {
  this.isReplace = true;
  replace.call(router, ...args);
};

router.beforeEach((to, form, next) => {
  const { title, backgroundColor, footer, home, auth } = to.meta;
  console.log(to.name, form.name);
  if (auth === true && !$store.state.app.token) {
    if (form.name === "Login") return;
    return toLogin(true, to.fullPath);
  }
  document.title = title || process.env.VUE_APP_NAME || "crmeb商城";
  //判断是否显示底部导航
  footer === true ? $store.commit("SHOW_FOOTER") : $store.commit("HIDE_FOOTER");

  //控制悬浮按钮是否显示
  home === false ? $store.commit("HIDE_HOME") : $store.commit("SHOW_HOME");

  $store.commit("BACKGROUND_COLOR", backgroundColor || "#F5F5F5");

  if (auth) {
    $store.dispatch("USERINFO").then(() => {
      next();
    });
  } else next();
});

export default router;
